import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import BenefitsSection from "./components/BenefitsSection";
import TrustSection from "./components/TrustSection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfans.wiki";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "name": "USFans Wiki",
      "url": siteUrl,
      "description": "Polska baza wiedzy o USFans Spreadsheet – poradniki, analizy i narzędzia dla agencji.",
      "inLanguage": "pl-PL",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${siteUrl}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "name": "USFans Wiki",
      "url": siteUrl,
      "description": "Polska baza wiedzy o creator database, analizach twórców i narzędziach dla agencji marketingowych.",
      "sameAs": [
        "https://kaspreadsheet.com/"
      ]
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Strona główna",
          "item": siteUrl
        }
      ]
    }
  ]
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <BenefitsSection />
      <TrustSection />
      <ArticlesSection />
      <FAQSection />
      <Footer />
    </main>
  );
}